import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useUser } from "@/features/auth/hooks/use-user";
import { cn } from "@/lib/utils";
import { UserIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { ThemeAndLanguageSwitcher } from "../theme-language";
import { useTranslation } from "@/features/utils/i18n";

export const EmbeddedCard = ({
  children,
  logo,
  className,
  themeAndLanguage,
  center,
}: {
  children: React.ReactNode;
  logo?: boolean;
  className?: string;
  themeAndLanguage?: boolean;
  center?: boolean;
}) => {
  const { t } = useTranslation();
  const { data: user } = useUser();
  const embed = document.location.search.includes("embed");

  return (
    <div
      className={cn(
        "flex flex-col min-h-dvh items-center p-0 md:p-2 md:justify-center justify-end",
        embed && "bg-white p-0 ",
        center === false && "justify-start",
      )}
    >
      {logo && !embed && (
        <div className="relative z-10 mb-6 hidden md:block">
          <img src="/logo/logo-on-white.svg" alt="HeyUp" className="h-9 w-auto dark:hidden" />
          <img src="/logo/logo-on-black.svg" alt="HeyUp" className="hidden h-9 w-auto dark:block" />
        </div>
      )}

      <Card
        className={cn(
          "relative z-10 w-full max-w-none rounded-b-none md:rounded-2xl md:max-w-sm shadow-overlay md:p-2 animate-[fade-in_0.2s_ease-out]",
          embed && "bg-white p-0 shadow-none rounded-none md:max-w-none",
          className,
        )}
      >
        {themeAndLanguage && (
          <div className="float-right flex space-x-1 mt-4 mr-4">
            {!!user?.id && (
              <Link to="/app/profile" target="_blank" rel="noreferrer">
                <Button
                  tooltip={t("common.accountSettings")}
                  variant="outline"
                  className="overflow-hidden relative h-7 w-7"
                >
                  <UserIcon />
                </Button>
              </Link>
            )}
            <ThemeAndLanguageSwitcher />
          </div>
        )}
        {children}
      </Card>

    </div>
  );
};
